import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import {QuestionCollection} from 'app/blocks/model/check-list-category.model';

export interface ISafetyProfile extends IBaseEntity {
    id?: number;
    name: string;
    showSafetyProfileOn: string;
    vehicleCount: number;
    trailerCount: number;
    categories?: QuestionCollection[];
    resources?: any[];
    assignResources?: {id: string}[];
    unassignResources?: {id: string}[];
}

export class SafetyProfile extends BaseEntity implements ISafetyProfile {
    public id?: number;
    public name: string;
    public showSafetyProfileOn: string;
    vehicleCount: number;
    trailerCount: number;
    public categories: QuestionCollection[];
    public resources: any[];
    public assignResources: {id: string}[];
    public unassignResources: {id: string}[];

    constructor(safetyProfile?: any) {
        super();
        if (safetyProfile) {
            this.id = safetyProfile.id;
            this.name = safetyProfile.name;
            this.showSafetyProfileOn = safetyProfile.showSafetyProfileOn;
            this.vehicleCount = safetyProfile.vehicleCount;
            this.trailerCount = safetyProfile.trailerCount;
            this.categories = safetyProfile.categories;
            this.resources = safetyProfile.resources || [];
            this.assignResources = safetyProfile.assignResources || [];
        }
        this.unassignResources = (safetyProfile && safetyProfile.unassignResources) || [];
    }

    get discriminator(): any {
        return this.name;
    }

    clone(): SafetyProfile {
        return new SafetyProfile(this);
    }
}
